import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import './styles/index.css';
import { BotAcademy } from './BotAcademy';
import { ErrorBoundary } from './ErrorBoundary';
import { configureScrivito } from './configureScrivito';
import { getInstanceIdFromPath } from './getInstanceIdFromPath';

configureScrivito();

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      {getInstanceIdFromPath() ? (
        <BotAcademy />
      ) : (
        <div>
          <h1>Error</h1>
          <p>No instance ID found in path.</p>
        </div>
      )}
    </ErrorBoundary>
  </StrictMode>,
);
